var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ColorForm',{attrs:{"color":null,"readOnly":false}})}
var staticRenderFns = []

export { render, staticRenderFns }